import React, { Fragment } from 'react';
import { css } from 'styled-components';
import PropTypes from 'prop-types';
import Title from './Title';
import Text from './Text';
import CTAButton from './CTAButton';

const CTA = ({ title, subTitle, onClick, event, buttonText, showFree }) => (
  <Fragment>
    <Title
      level={3}
      styles={css`
        align-self: center;
      `}
      medium
      align="center"
    >
      {title}
    </Title>
    <Text type="body2" align="center">
      {subTitle}
    </Text>
    <CTAButton
      nolink
      blank
      customOnClick={() => {
        onClick();
      }}
      linkStyles={css`
        margin-top: 0.5rem;
      `}
      buttonText={buttonText}
      event={event}
    />
    {showFree && (
      <Text type="successMessage" medium>
        Es gratis... Sí, en serio
      </Text>
    )}
  </Fragment>
);

CTA.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  event: PropTypes.string,
  onClick: PropTypes.func,
  buttonText: PropTypes.string,
  showFree: PropTypes.bool,
};

CTA.defaultProps = {
  title: '',
  subTitle: '',
  event: '',
  buttonText: 'Empezar ahora',
  showFree: true,
  onClick: () => {},
};

export default CTA;
